import { Instance } from 'mobx-state-tree';
import { WebhookDeliveryAttemptDtoModelBase } from './WebhookDeliveryAttemptDtoModel.base';

/* The TypeScript type of an instance of WebhookDeliveryAttemptDtoModel */
export interface WebhookDeliveryAttemptDtoModelType extends Instance<typeof WebhookDeliveryAttemptDtoModel.Type> {}

/* A graphql query fragment builders for WebhookDeliveryAttemptDtoModel */
export { selectFromWebhookDeliveryAttemptDto, webhookDeliveryAttemptDtoModelPrimitives, WebhookDeliveryAttemptDtoModelSelector } from './WebhookDeliveryAttemptDtoModel.base';

/**
 * WebhookDeliveryAttemptDtoModel
 */
export const WebhookDeliveryAttemptDtoModel = WebhookDeliveryAttemptDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
